import { Component, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Buyer } from 'src/app/core/buyers.service';
import { ErrorService, SplittypayError } from 'src/app/core/error.service';
import { StripePaymentSource, StripePaymentSourcesService } from 'src/app/core/stripe-payment-sources.service';
import { ERROR_STRIPE_PAYMENT_SOURCES_NOT_FOUND_CODE } from 'src/app/shared/constants/operationals';

@Component({
  selector: 'app-buyers-edit-card-dialog',
  templateUrl: './buyers-edit-card-dialog.component.html',
  styleUrls: ['./buyers-edit-card-dialog.component.scss'],
})
export class BuyersEditCardDialogComponent {
  buyer?: Buyer;
  is_sources_list_running: boolean = false;
  payment_sources?: StripePaymentSource[];
  payment_source?: StripePaymentSource;
  is_delete_running: boolean = false;

  constructor(
    private dialog_ref: MatDialogRef<BuyersEditCardDialogComponent>,
    @Inject(MAT_DIALOG_DATA) data: any,
    private stripe_payment_sources_service: StripePaymentSourcesService,
    private error_service: ErrorService,
    private stripe_payment_source_service: StripePaymentSourcesService,
  ) {
    this.buyer = data.buyer;
  }

  ngOnInit(): void {
    this.listPaymentSources();
  }

  onCloseClick(): void {
    this.dialog_ref.close();
  }

  onConfirmClick(): void {
    if (this.payment_source && this.payment_source?.buyer_stripe_payment_source_id && this.buyer?.buyer_id) {
      this.is_delete_running = true;
      this.stripe_payment_source_service
        .deletePaymentSource(this.payment_source.buyer_stripe_payment_source_id, this.buyer.buyer_id)
        .subscribe({
          next: () => {
            this.dialog_ref.close({ success: true });
            this.is_delete_running = false;
          },
          error: error => {
            const processed_error: SplittypayError = this.error_service.preProcessApiError(error);
            this.dialog_ref.close({ error: processed_error });
            this.is_delete_running = false;
          },
        });
    } else {
      this.dialog_ref.close({ success: false });
      this.is_delete_running = false;
    }
  }

  listPaymentSources(): void {
    if (this.buyer?.buyer_id) {
      this.is_sources_list_running = true;
      this.stripe_payment_sources_service.listPaymentSources(this.buyer?.buyer_id).subscribe({
        next: response => {
          this.payment_sources = response.data;
          this.is_sources_list_running = false;
        },
        error: error => {
          const processed_error: SplittypayError = this.error_service.preProcessApiError(error);
          if (processed_error.code == ERROR_STRIPE_PAYMENT_SOURCES_NOT_FOUND_CODE) {
            this.payment_sources = [];
          } else {
            this.error_service.processApiError(processed_error.code, processed_error.message);
          }
          this.is_sources_list_running = false;
        },
      });
    }
  }
}
